

























import { defineComponent, PropType } from '@vue/composition-api';
import { MessageEventSetItem, PixelStatus } from '@tt4b/ttam-enums';

const name = 'ttam-message-event-set-list-item';

export default defineComponent({
  name,
  props: {
    source: {
      type: Object as PropType<MessageEventSetItem>,
      default: () => ({}),
    },
    handleClick: {
      type: Function as PropType<(i: MessageEventSetItem) => void>,
      default: () => () => undefined,
    },
  },
  setup() {
    return {
      name,
      PixelStatus,
    };
  },
});
